"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MINIMUM_SHOW_ADD_BUTTON = exports.ONE_WEEK_MILLI = exports.ONE_DAY_MILLI = exports.ONE_HOUR_MILLI = exports.ONE_MINUTE_MILLI = exports.MAX_AGENDA_PASTE_LENGTH = exports.MAX_WAITING_ROOM_MESSAGE_LENGTH = exports.MIN_PASSWORD_LENGTH = exports.MAX_ROOM_QUEUE_NOTE_LENGTH = exports.MIN_USERNAME_ROOM_LENGTH = exports.MAX_USERNAME_ROOM_LENGTH = void 0;
exports.MAX_USERNAME_ROOM_LENGTH = 25;
exports.MIN_USERNAME_ROOM_LENGTH = 3;
exports.MAX_ROOM_QUEUE_NOTE_LENGTH = 140;
exports.MIN_PASSWORD_LENGTH = 6;
exports.MAX_WAITING_ROOM_MESSAGE_LENGTH = 50;
exports.MAX_AGENDA_PASTE_LENGTH = 255;
exports.ONE_MINUTE_MILLI = 60000;
exports.ONE_HOUR_MILLI = exports.ONE_MINUTE_MILLI * 60;
exports.ONE_DAY_MILLI = exports.ONE_HOUR_MILLI * 24;
exports.ONE_WEEK_MILLI = exports.ONE_DAY_MILLI * 7;
exports.MINIMUM_SHOW_ADD_BUTTON = 4;
//# sourceMappingURL=numbers.js.map